import React, { useEffect } from "react";
import { useThree } from "@react-three/fiber";

/**
 * CameraStateBridge — lives inside the <Canvas>. Writes a stable getter to the
 * provided ref so the HUD (which lives OUTSIDE the Canvas) can read the
 * current camera position and OrbitControls target on demand (e.g. for the
 * "Share this view" button).
 */
export default function CameraStateBridge({ stateRef, controlsRef }) {
  const { camera } = useThree();

  useEffect(() => {
    if (!stateRef) return;
    stateRef.current = {
      getPose: () => {
        const c = camera.position;
        const t = controlsRef && controlsRef.current && controlsRef.current.target;
        return {
          cam: [c.x, c.y, c.z],
          target: t ? [t.x, t.y, t.z] : null,
        };
      },
    };
  }, [camera, stateRef, controlsRef]);

  return null;
}
